var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.16675 11.3077V6.32435C2.16675 4.02435 4.03341 2.16602 6.33341 2.16602H14.6667C16.9667 2.16602 18.8334 4.02435 18.8334 6.32435V12.141C18.8334 14.4327 16.9667 16.291 14.6667 16.291H13.4167C13.1584 16.291 12.9084 16.416 12.7501 16.6243L11.5001 18.2827C10.9501 19.016 10.0501 19.016 9.50008 18.2827L8.25008 16.6243C8.11675 16.441 7.81675 16.291 7.58341 16.291H6.33341C4.03341 16.291 2.16675 14.4327 2.16675 12.141V11.3077Z",
    fill: "#111111",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5001 10.5007C10.0334 10.5007 9.66675 10.1257 9.66675 9.66732C9.66675 9.20898 10.0417 8.83398 10.5001 8.83398C10.9584 8.83398 11.3334 9.20898 11.3334 9.66732C11.3334 10.1257 10.9667 10.5007 10.5001 10.5007Z",
    fill: "#111111",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 10.5007C13.3667 10.5007 13 10.1257 13 9.66732C13 9.20898 13.375 8.83398 13.8333 8.83398C14.2917 8.83398 14.6667 9.20898 14.6667 9.66732C14.6667 10.1257 14.3 10.5007 13.8333 10.5007Z",
    fill: "#111111",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16659 10.5007C6.69992 10.5007 6.33325 10.1257 6.33325 9.66732C6.33325 9.20898 6.70825 8.83398 7.16659 8.83398C7.62492 8.83398 7.99992 9.20898 7.99992 9.66732C7.99992 10.1257 7.63325 10.5007 7.16659 10.5007Z",
    fill: "#111111",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.e79bd23c880f0ed43c4df1a6a7c28235.svg";
export { ForwardRef as ReactComponent };